import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { authInterceptor } from './modules/client/auth/interceptors/auth.interceptor';
import { AuthService } from './modules/client/auth/services/auth.service';
import { adminAuthInterceptor } from './modules/admin/auth/interceptors/admin-auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled'
    })),
    provideHttpClient(withInterceptors([adminAuthInterceptor, authInterceptor])),
    // Restablecer la sesión de Amplify al iniciar la aplicación para que la señal del token esté lista
    // antes de que se active cualquier componente o solicitud HTTP: Amplify lee desde su propio
    // localStorage y actualiza automáticamente el token de acceso si es necesario.
    // EXCEPCIÓN: si force_logout=1 está en la URL (puesto por events.js cuando detecta que WP
    // acaba de completar un logout), limpiamos las claves de Amplify de ESTA partición de
    // almacenamiento directamente y saltamos loadSessionToken() para no hacer fetchAuthSession().
    // Esto es necesario por Chrome Storage Partitioning: el iframe tiene una partición de
    // localStorage separada de la del panel, por lo que logout() del panel no borra los tokens
    // que Amplify guardó aquí cuando el usuario hizo login dentro del iframe.
    provideAppInitializer(async () => {
      const authService = inject(AuthService);
      try {
        if (new URLSearchParams(window.location.search).get('force_logout') === '1') {
          console.log('[ELD-AUTH] force_logout=1 en app init — limpiando tokens del iframe');
          authService.wipeAmplifyStorageKeys();
          return;
        }
      } catch { /* no-op */ }
      return authService.loadSessionToken();
    }),
  ]
};

